import React, { useEffect, useState } from "react";
import {
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import AssignCfts from "./NsaTabs/AssignCfts/AssignCfts";
import ViewDetailedReport from "./NsaTabs/ViewDetailedReport/ViewDetailedReport";
import ImprovementPlan from "./NsaTabs/ImprovementPlan/ImprovementPlan";

const Nsa = ({ viewDataFromSupplier }) => {


  const [activeTab, setActiveTab] = useState("1");
  const [auditStatusTab, setAuditStatusTab] = useState(null)
  const [viewDataFromReport, setViewDataFromReport] = useState(null)
  const [approveDateFlagCheck, setAuditStatusFlagCheck] = useState(null)
  const [deleteFlagCheck,setDeleteFlagCheck] = useState(null)


  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const openViewDetailReport = queryParams.get("vdr");
    if (openViewDetailReport === "true") {
      setActiveTab("3")
    }
  }, [])


  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <div className="hl-vendor-need-approval-wrap hl-vl-common-wrap mt-3">
      {/* <div className={activeTab == "2" ? "" : hlverticaltabs}> */}
      <div className="hl-vertical-tabs">
        <Row className="hl-tab">
          <Col lg="2">
            <div className="h-100">
              <Nav vertical tabs>
                <NavItem className={activeTab === "1" ? "active" : ""}>
                  <NavLink onClick={() => toggleTab("1")}>Assign CFTs</NavLink>
                </NavItem>
                {/* <NavItem className={activeTab === '2' ? 'active' : ''}>
                                    <NavLink onClick={() => toggleTab('2')}>
                                        CFT Assessment Form
                                    </NavLink>
                                </NavItem> */}
                <NavItem className={activeTab === "3" ? "active" : ""}>
                  <NavLink
                    onClick={() => toggleTab("3")}
                  // disabled={
                  //   viewDataFromSupplier?.ReportSubmitDate===null
                  // }
                  >
                    View Detailed Report
                  </NavLink>
                </NavItem>
                <NavItem className={activeTab === "5" ? "active" : ""}>
                  <NavLink
                    onClick={() => toggleTab("5")}
                    disabled={approveDateFlagCheck == null}
                  >
                    Improvement Plan
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </Col>
          <Col lg="10">
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <AssignCfts viewDataFromSupplier={viewDataFromSupplier} auditStatusTab={auditStatusTab} deleteFlagCheck={deleteFlagCheck} />
              </TabPane>
              <TabPane tabId="3">
                <ViewDetailedReport

                  viewDataFromSupplier={viewDataFromSupplier}
                  setAuditStatusTab={setAuditStatusTab}
                  setDeleteFlagCheck={setDeleteFlagCheck}
                  setAuditStatusFlagCheck={setAuditStatusFlagCheck}
                  setViewDataFromReport={setViewDataFromReport}
                />
              </TabPane>

              {/* <TabPane tabId="4" >
                                <ViewDetailedReportReplica />
                            </TabPane> */}

              <TabPane tabId="5">
                <ImprovementPlan viewDataFromSupplier={viewDataFromSupplier} viewDataFromReport={viewDataFromReport} />
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Nsa;
